import axios from 'axios';
import CONFIG from '../../config.js';

const request = axios.create({
  baseURL: `${CONFIG.apiBaseURL}/api`,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});

// 响应拦截器：统一提取数据
request.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.status === true || res.status === 'success' || res.status === 200) {
      return res.data;
    }
    return Promise.reject(new Error(res.message || '请求失败'));
  },
  (error) => {
    console.error('API请求失败:', error.message);
    return Promise.reject(error);
  },
);

// 资讯相关
export const newsApi = {
  getList: (params) => request.get('/app/news', { params }),
  getDetail: (id) => request.get(`/app/news/${id}`),
  getCategories: () => request.get('/app/news/categories'),
};

// 赛事相关
export const eventApi = {
  getList: (params) => request.get('/app/tournaments', { params }),
  getDetail: (id) => request.get(`/app/tournaments/${id}`),
};

// 轮播图
export const bannerApi = {
  getList: () => request.get('/app/banners'),
};

export default request;
